import { Check } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { useToast } from "@/hooks/use-toast";
import { supabase } from "@/integrations/supabase/client";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

export const PremiumFeatures = () => {
  const { toast } = useToast();
  const navigate = useNavigate();
  const [isSubscribed, setIsSubscribed] = useState<boolean | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    checkSubscription();
  }, []);

  const checkSubscription = async () => {
    try {
      const { data: { session } } = await supabase.auth.getSession();
      if (!session) {
        setIsSubscribed(null);
        return;
      }

      const { data, error } = await supabase.functions.invoke('check-subscription');
      if (error) throw error;
      setIsSubscribed(data.subscribed);
    } catch (error) {
      console.error('Error checking subscription:', error);
      toast({
        title: "Error",
        description: "Could not check subscription status",
        variant: "destructive",
      });
    }
  };

  const handleSubscribe = async () => {
    try {
      setIsLoading(true);
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session) {
        navigate('/login');
        return;
      }

      const { data, error } = await supabase.functions.invoke('create-checkout');
      if (error) throw error;

      if (data?.url) {
        window.location.href = data.url;
      }
    } catch (error) {
      console.error('Error creating checkout session:', error);
      toast({
        title: "Error",
        description: "Could not start checkout process",
        variant: "destructive",
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <section className="py-12 md:py-16 px-4 bg-primary/5">
      <div className="container mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold mb-6">Premium Features</h2>
        <div className="max-w-3xl mx-auto mb-8">
          <Card className="p-6 md:p-8">
            <h3 className="text-xl md:text-2xl font-semibold mb-4">
              {isSubscribed ? "You're a Premium Member!" : "Upgrade to Premium"}
            </h3>
            <ul className="text-left space-y-3 mb-6">
              <li className="flex items-center">
                <Check className="mr-2 h-5 w-5 text-primary" />
                Unlimited chat conversations
              </li>
              <li className="flex items-center">
                <Check className="mr-2 h-5 w-5 text-primary" />
                Advanced DBT techniques and exercises
              </li>
              <li className="flex items-center">
                <Check className="mr-2 h-5 w-5 text-primary" />
                Priority support
              </li>
              <li className="flex items-center text-primary font-medium mt-4">
                <Check className="mr-2 h-5 w-5 text-primary" />
                All Profits are donated to BPD Research
              </li>
            </ul>
            {!isSubscribed && (
              <Button 
                onClick={handleSubscribe} 
                disabled={isLoading}
                className="w-full md:w-auto"
              >
                {isLoading ? "Loading..." : "Subscribe Now"}
              </Button>
            )}
          </Card>
        </div>
      </div>
    </section>
  );
};